
import RcDomainMap from "../../common/RcDomainMap.js";
import Registration from './Registration.js';
import RegistrationUtils from './RegistrationUtils.js';

export default class RegistrationMap extends RcDomainMap {
  
  static MODEL_NAME = "RegistrationMap";
  
  constructor(domain, data) {
    super(domain, data, RegistrationMap.MODEL_NAME);
  }

  copy() {
    var data = this._copy();
    return new RegistrationMap(this.domain, data);
  }
  
  sort() {
    return this.sortByCreatedDateZa();
  }
  
  sortByCreatedDateZa() {
    var list = this.list();
    let functionName = 'SortBy_createdDateZa';
    var func = RegistrationUtils[functionName];
    return list.sort(func);
  }
  
  sortBy(fieldName) {
    var list = this.list();
    let functionName = 'SortBy_' + fieldName;
    var func = RegistrationUtils[functionName];
    return list.sort(func);
  }

  find() {
    var keys = this.keys();
    var found = new RegistrationMap(this.domain, {} );
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = this.domain.registrations().findById(key);
      var item = new Registration(this.domain, data);
      if (!item.isNew()) {
        found.add(item);
      }
    }
    return found;
  }
  
  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getRegistration(key);
      values.push(item);
    }
    return values;
  }
  
  first() {
    var all = this.list();
    if (all.length > 0) {
      return all[0];
    }
    return new Registration(this.domain);
  }
  
  getRegistration(key) {
    var value = super.get(key);
    return new Registration(this.domain, value);
  }
}